export const BUSINESS_ACCOUNT_TEXT = {
    title: 'Бизнес-аккаунт товары',
    description: 'Для брендов, продающих товары',
};

export const SERVICE_ACCOUNT_TEXT = {
    title: 'Бизнес-аккаунт услуги',
    description: 'Для компаний и специалистов, оказывающих услуги',
};

export const BLOGGER_ACCOUNT_TEXT = {
    title: 'Профиль автора',
    description: 'Для тех, кто ведет блог и активно развивает сообщество',
};
